export default class ValidateEntityObject {
  public static validate(obj: any, callback: Function): any {
    return (obj !== null && obj !== undefined)
      ? callback(obj)
      : callback({});
  }
}
